<template>
  <main>
    <section class="box" v-loading="loading" :element-loading-text="elementLoadingText"
      :style="{ background: 'url(' + travelData.productInfo.cover_url + ')' }">
      <div class="productInfoWrap">
        <!-- 订单产品信息 -->
        <div class="orderDetailWrap">
          <h1>{{ travelData.productInfo.name }}</h1>
          <h3>{{ travelData.SkuInfoName }}</h3>
          <div class="travelDesc">出发日期: <b>{{ travelData.sku_travel_date.date || '--' }}</b></div>
          <div class="travelDesc">购买数量: <b>{{ travelData.sku_quantity || '--' }}</b></div>
          <div class="travelDesc">单价: <b>￥{{ travelData.unit_price || '--' }}</b></div>
        </div>

        <!-- 联系信息 -->
        <div class="concatInfo">
          <h4><b>出行信息</b></h4>
          <div class="options">
            <div class="item">
              <span>联系人姓名</span>
              <div>
                <input v-model="contact.contact_name" type="text" placeholder="请输入联系人姓名" />
              </div>
            </div>
            <div class="item">
              <span>联系电话</span>
              <div>
                <input maxlength="11" v-model="contact.contact_phone" type="tel" placeholder="请输入联系人手机号码" />
              </div>
            </div>
            <div class="item">
              <span>电子邮箱</span>
              <div>
                <input maxlength="30" v-model="contact.contact_email" type="email" placeholder="请输入联系人电子邮箱" />
              </div>
            </div>
            <div class="item fullLineWrap">
              <span>备注</span>
              <div>
                <input v-model="contact.remark" type="tel" placeholder="请输入备注" />
              </div>
            </div>
          </div>

        </div>

        <!-- 支付信息 -->
        <div class="paymentInfo" v-if="getCountStatus">
          <h4>支付类型</h4>
          <el-radio-group v-model="chooseSettleType">
            <el-radio :label="item.id" v-for="(item, index) in paymentMethods" :key="index"
              @click="selectSettleType(item.id)">{{ item.text }}</el-radio>
          </el-radio-group>
        </div>

        <!-- 支付功能 -->
        <div class="pay">
          <figure>
            <span>应付总额：</span>
            <b>{{ Number(travelData.sku_quantity * getSelectedUnitPrice).toFixed(2) }}</b>
          </figure>
          <el-button round type="primary" @click="goPay">去支付</el-button>
        </div>


      </div>


    </section>
  </main>
</template>

<script>
import moment from 'moment';
import $strategy from '@assets/js/strategy';
import isIdCard from '@assets/js/idCard';
import $tour from '@api/tour';
import $coupon from '@api/coupon';


export default {
  data() {
    return {
      paymentMethods: [
        {
          id: 'dealer_price',
          text: '分销商价'
        },
        {
          id: 'retail_price',
          text: '零售价'
        }
      ],
      chooseSettleType: 'retail_price', //选择的结算方式 默认零售价
      travelData: {},//sessionstorage中的订单相关数据
      loading: false,
      param: {}, // 接受的传参
      price_level_id: null,
      tourGroups: [],
      contact: {
        contact_name: '',
        contact_phone: '',
        remark: '',
        contact_email: ''
      },
      tourist: [],
      elementLoadingText: null,
      coupon: [],
      couponIndex: 0,
    }
  },
  filters: {
  },
  computed: {
    userInfo() {
      return this.getUserInfo();
    },
    // 通过选择的结算类型,返回默认的产品单价
    getSelectedUnitPrice() {
      let _this = this;
      let unitPrice = 0;
      unitPrice = _this.travelData.selectedSkuInfo[_this.chooseSettleType] || 0;
      return Number(_this.ConversionPrice(unitPrice));
    },
    // 判断 结算方式的显示状态 , 当没有 分销商价格时 不显示 ， 结算的默认方式为：零售价
    getCountStatus() {
      let _this = this;
      let PaymentsStatus = false;
      if (_this.travelData && _this.travelData.selectedSkuInfo && Object.keys(_this.travelData.selectedSkuInfo).length) {
        if (_this.travelData.selectedSkuInfo.dealer_price) {
          _this.chooseSettleType = 'dealer_price';
          PaymentsStatus = true;
        }
      }
      return PaymentsStatus;
    }
  },
  async created() {
    let _this = this;
    const param = this.getTravelData();
    if (!param) {
      this.$message.warning('非法路径!');
      this.$router.push({ name: 'tour' });
      return;
    }
    _this.travelData = param;

    this.initContact();//初始化联系方式
    // this.changeTourist();
  },
  methods: {

    // 将数字转为 正常显示的价格
    ConversionPrice(price) {
      return price ? (Number(price) / 100).toFixed(2) : 0;
    },
    // 选择结算方式;
    selectSettleType(id) {
      this.chooseSettleType = id;
    },

    //点击
    async Refresh() {
      const param = this.getParams();
    },

    changeTourist() {
      const { child, adult } = this.param;
      const len = child + adult;
      let tourist = Array.from({ length: len }, (x, i) => (
        {
          id_number: '',
          phone: '',
          cn_name: '',
          // 护照信息
          passport_number: '',
          effective_date: ''
        }
      ));
      tourist = [...this.tourist, ...tourist].slice(0, len);
      this.tourist = tourist;
      this.Refresh();
    },
    // 初始化联系方式
    initContact() {
      const { contact_name, customerMobile: contact_phone } = this.userInfo;
      this.contact = { ...this.contact, contact_name, contact_phone };
    },
    // 从sessionStorage中获取旅游订单信息相关内容
    getTravelData() {
      let param = JSON.parse(sessionStorage.getItem('tourOrder') || 'null');
      return param;
    },
    changeParam(attr, value) {
      const param = { ...this.param, [attr]: value };
      this.param = param;
      this.Refresh();

    },
    changeDay(v) {
      if (!v.on) { return; }
      this.changeParam('day', v);
    },
    // 发起订单
    async goPay() {
      let _this = this;

      if (this.checkData() === false) { return; }
      const data = this.getRequestData();
      await $tour.saveTravelOrder(data).then((res) => {
        if (res.status == "success") {
          const { order_sn } = res.data;
          sessionStorage.removeItem('tourOrder');
          _this.$router.push({ name: 'tour_pay', query: { order_sn } });
        } else {
          _this.$message.warning('添加订单失败!'); return;
        }
      })

    },
    // 获取提交旅游订单的参数
    getRequestData() {
      let _this = this;
      const { contact: { contact_name, contact_phone, contact_email, remark }, travelData } = this;
      const { sku_id, sku_quantity, sku_travel_date } = travelData;
      let formInfo = {
        contact_name,
        contact_phone,
        contact_email,
        remark,
        sku_id,
        sku_quantity,
        sku_travel_date: sku_travel_date.date,
        price_field_name: _this.chooseSettleType
      };
      for (let i in formInfo) {
        if (!formInfo[i] || formInfo[i] == null || formInfo[i] == undefined) {
          delete formInfo[i];
        }
      }

      return formInfo;

    },
    // 校验 提交参数
    checkData() {
      const { contact: { contact_name, contact_phone }, travelData } = this;
      if (!contact_name) {
        this.$message.warning('联系人名称不能为空!');
        return false;
      }
      if (travelData.sku_quantity == 0) {
        this.$message.warning('人数不能为0!');
        return false;
      }
      if (!$strategy.check(contact_phone, 'isMobile')) {
        this.$message.warning('联系人手机格式有误!');
        return false;
      }
      // if (this.checkTour() === false) {
      //   return false;
      // }
      return true;
    },
    checkTour() {
      const { tourist } = this;
      let res = true;
      for (let v of tourist) {
        const { cn_name, phone, id_number, passport_number, effective_date } = v;
        // 检测名称
        if (!cn_name) {
          this.$message.warning('出游人姓名不能为空！');
          res = false; break;
        }
        // 检测手机
        if (!$strategy.check(phone, 'isMobile')) {
          this.$message.warning('出游人手机号有误！');
          res = false; break;
        }
        // 检测身份证
        if (!isIdCard(id_number)) {
          this.$message.warning('出游人身份证有误！');
          res = false; break;
        }
        if (this.info.need_passport === 1) {
          if (!!passport_number === false || !!effective_date === false) {
            this.$message.warning('请检查护照信息!');
            res = false; break;
          }
        }
      }
      return res;
    }
  }
}
</script>

<style scoped src="./add.css"></style>
<style scoped>
.uls {
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  box-sizing: border-box;
  max-height: calc(100% - 50px);
  overflow: auto;

  li {
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: space-between;
    background-color: #f1f1f1;
    border-radius: 5px;
    width: 100%;
    margin-bottom: 15px;
    padding: 10px;
    min-height: 60px;
    box-sizing: border-box;
    border-radius: 10px;

    &:nth-of-type(3n-1) {
      /* margin: 0 15px 15px; */
    }

    figure {
      display: flex;
      align-items: center;
      font-size: 12px;
      color: var(--txt_secondary);

      .price {
        flex: none;

        span {
          display: block;
          text-align: center;

          &:first-of-type {
            color: var(--err);
            font-size: 18px;
            font-weight: bold;
            padding: 0 0 3px;

            &:before {
              content: '¥';
              font-size: 0.8em;
              padding: 0 2px 0 0;
            }
          }
        }
      }

      .info {
        padding: 0 0 0 10px;

        span {
          display: block;

          &.title {
            font-size: 14px;
            font-weight: bold;
            color: #232323;
            padding: 0 0 5px;
            display: block;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            width: 130px;
          }
        }
      }
    }

    .icon-gou {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 30px;
      height: 30px;
      border-radius: 50%;
      background-color: #fff;
      font-size: 10px;
      color: #fff;

      &.on {
        background-color: var(--err);
      }
    }
  }
}

.dd {

  figure {
    p {
      padding: 10px 0 0;
      width: 100%;

      span {
        width: 100px;
        color: var(--txt_placeholder);
      }

      b {
        color: var(--txt_secondary);

        &:before {
          content: '¥';
          padding: 0 5px 0 0;
          font-size: var(--fs_s);
        }

        &:empty:before {
          content: '--';
        }
      }

      /* &:last-of-type {
          b {
            color: var(--err);
            font-size: 32px;
            &:before {
              font-size: var(--fs_m);
            }
          }
        } */
    }
  }
}
</style>
